<template>
  <v-dialog
  max-width="500px"
  v-model="showJobDetailModal"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  persistent
  >
    <v-card v-if="job.id" :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-container class="modal-pad"  :style="modalHeight" >
        <v-layout row align-center wrap mb-3>
          <v-flex  xs10 style="height:30px;">
            <transition-group name="slide" mode="out-in" class="head-slide">
            <span class="subheading" v-if="activeTab === 0" :key="activeTab">Job details</span>
            <span class="subheading" v-if="activeTab === 1" :key="activeTab">Sub tasks</span>
            <span class="subheading" v-if="activeTab === 2" :key="activeTab">Time tracking</span>
            <span class="subheading" v-if="activeTab === 3" :key="activeTab">Job notes</span>
            </transition-group>
          </v-flex>
          <v-flex xs2 >
            <span class="done-button" @click="closeWindow">done</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap >
          <!-- replace with slide group in vuetify 2? -->
          <v-tabs
          ref="menutabs"
          style="width:100%;"
          v-model="activeTab"
          :hide-slider='true'
          class="m-0 p-0 modal-tabs"
          >
          <div style="border-bottom:1px solid rgba(0, 0, 0, .2); width:100%; " >
            <v-tab :ripple='false' key="tab1" class="m-0 p-0">
              <span class="tab-button">details</span>
            </v-tab>
            <v-tab :ripple='false' key="tab2" class="m-0 p-0">
              <span class="tab-button">tasks</span>
            </v-tab>
            <v-tab :ripple='false' key="tab3" class="m-0 p-0">
              <span class="tab-button">time</span>
            </v-tab>
            <v-tab :ripple='false' key="tab4" class="m-0 p-0">
              <span class="tab-button">notes</span>
            </v-tab>
          </div>
            <v-tab-item key="tab1" class="jobtab ">
              <v-card flat width="100%">
                <v-card-text class="px-0">
                  <!-- Name of Client -->
                  <v-combobox
                    v-model="client_nameFormatted"
                    label="Client"
                    :items="clients"
                    item-text="name"
                    item-value="name"
                    hide-details
                    dense
                    placeholder="Choose or add a client"
                    @input="saveClientName()"
                    :autofocus="client_nameFormatted === ''"
                    ref="clientname"
                  ></v-combobox>
                  <line-items
                  class="pb-4"
                    :lineItems="job.lineItems"
                    :newLineItemKey="newLineItemKey"
                    :itemAmount="job.amount"
                    :itemTotalTaxPortion="job.totalTaxPortion"
                    :itemTotalNetAmount="job.totalNetAmount"
                    :itemTitle="job.title"
                    :itemTaxIncluded="job.taxIncluded"
                    @create-new-key="getLineItemKey"
                    @line-items-output="updateJobFromLineItems"
                  />
                  <!--<div class="pb-4" @click="copyJob()"><v-icon>content_copy</v-icon></div>-->
                  <!-- Name of Contact -->
                  <v-text-field v-if="listId === 1"
                    name="contact"
                    label="Name of contact"
                    :id="`contact-${listId}`"
                    v-model="job.contact"
                    type="text"
                    required
                    hide-details
                    placeholder=" "
                    @change="updateJob(job)"
                    @keyup.enter="updateJob(job)"
                  ></v-text-field>
                  <!-- Invoice Ref -->
                  <!-- <v-text-field v-if="listId === 4 || listId === 5"
                    name="invoice_ref"
                    label="Invoice ref"
                    :id="`invoice_ref-${listId}`"
                    v-model="job.invoice_ref"
                    type="text"
                    required
                    hide-details
                    placeholder=" "
                    @change="updateJob(job)"
                    @keyup.enter="updateJob(job)"
                  ></v-text-field> -->
                  <!-- Date pickers -->
                  <!-- Chase Date -->
                  <date-input v-if="listId === 1" date-name="chase_date" :date-in="job.chase_date" @update-date="updateDate" class="mb-3"/>
                  <!-- Quoted Date -->
                  <!--<date-input v-if="listId === 1" date-name="quoted_date" :date-in="job.quoted_date" @update-date="updateDate" />-->
                  <!-- start Date -->
                  <date-input v-if="listId === 2" date-name="start_date" :date-in="job.start_date" @update-date="updateDate"/>
                  <!-- Deadline Date -->
                  <date-input v-if="listId === 3" date-name="deadline_date" :date-in="job.deadline_date" @update-date="updateDate"/>
                  <!-- Invoiced Date -->
                  <date-input v-if="listId === 4" date-name="invoiced_date" :date-in="job.invoiced_date" @update-date="updateDate"/>
                  <!-- Paid Date -->
                  <date-input v-if="listId === 5" date-name="paid_date" :date-in="job.paid_date" @update-date="updateDate"/>
                  <v-layout
                  :row="!$vuetify.breakpoint.xsOnly"
                  :column="$vuetify.breakpoint.xsOnly"
                  fill-height
                  mt-3
                  class="pt-0 pb-0">
                      <div v-if="listId !== 1" style="position:relative;">
                      <v-btn class="mx-0 action-button-padding"
                      :block="$vuetify.breakpoint.xsOnly"
                      depressed
                      color="primary"
                      @click="goToInvoice(job.id)" >{{invoiceButtonText}}</v-btn>
                      <v-menu offset-y left :style="$vuetify.breakpoint.xsOnly ? 'position:absolute; top:0; right:0;' : ''">
                        <v-btn style="margin-left:-5px;" slot="activator" color="primary" dark depressed class=" px-1 actions-arrow">
                          <v-icon class="dropdown">arrow_drop_down</v-icon>
                        </v-btn>
                        <v-list dense>
                          <v-list-tile @click="doSplitInvoice(job)">
                            <v-list-tile-title >Create partial invoice?</v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile v-if="this.job.hasQuote && hasProAccess" @click="goToQuote(job.id)">
                            <v-list-tile-title >View quote</v-list-tile-title>
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                      </div>
                      <div v-if="listId === 1 && hasProAccess" style="position:relative;">
                      <v-btn class="mx-0 action-button-padding"
                      :block="$vuetify.breakpoint.xsOnly"
                      depressed
                      color="primary"
                      @click="goToQuote(job.id)" >{{quoteButtonText}}</v-btn>
                      </div>
                      <!-- archive button
                      <div v-if="listId !== 6" style="position:relative;">
                        <archive-job-button :jobId="job.id" :listId="job.listId" @job-moved="showJobDetailModal = false"/>
                      </div>-->
                      <v-spacer></v-spacer>
                      <div class="pt-3">
                        <move-job-button v-if="$vuetify.breakpoint.xsOnly" :jobId="job.id" :hasInvoice="job.hasInvoice" :listId="job.listId" :invoiceRef="job.invoice_ref" @job-moved="showJobDetailModal = false"/>
                      </div>
                      <div>
                        <delete-job-button :jobId="job.id" :listId="listId" @job-deleted="showJobDetailModal = false"/>
                      </div>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <!-- Job Tasks -->
            <v-tab-item key="tab2" class="taskstab">
              <job-tasks :job="job"/>
            </v-tab-item>
            <!-- Job Times -->
            <v-tab-item key="tab3" class="timetab">
              <job-times :job="job"/>
            </v-tab-item>
            <!-- Job Notes -->
            <v-tab-item key="tab4" class="notetab">
              <v-card flat class="pa-0 ">
                <v-card-text class="pa-0">
                  <v-textarea
                    name="note"
                    label=""
                    rows="13"
                    :id="`title-${listId}`"
                    v-model="job.note"
                    required
                    hide-details
                    placeholder="Add notes"
                    @change="updateJob(job)"
                    @keyup.enter="updateJob(job)"
                  ></v-textarea>
                </v-card-text>
              </v-card>
            </v-tab-item>
        </v-tabs>
        </v-layout>
      </v-container>
    </v-card>
    <confirm ref="confirm"></confirm>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'
import firebase from 'firebase/app'
import 'firebase/database'
import Confirm from '@/components/Shared/Confirm'
import DateInput from '@/components/Shared/DateInput'
import JobTasks from '@/components/Shared/JobTasks'
import JobTimes from '@/components/Shared/JobTimes'
import DeleteJobButton from '@/components/Shared/DeleteJobButton'
import MoveJobButton from '@/components/Shared/MoveJobButton'
import ArchiveJobButton from '@/components/Shared/ArchiveJobButton'
import LineItems from '@/components/Shared/LineItems'

export default {
  name: 'JobDetailModal',
  components: {
    Confirm,
    DateInput,
    JobTasks,
    JobTimes,
    DeleteJobButton,
    MoveJobButton,
    ArchiveJobButton,
    LineItems
  },
  mixins: [formatDate],
  data () {
    return {
      user: this.$store.getters.user,
      group: this.$store.getters.group,
      client_nameFormatted: '',
      alertThreshold: this.$store.getters.group.chosenAlertTimeScale,
      latestJobKey: this.$store.getters.latestJobKey, // gets the latest key added so we can open the job up if it;s the newset,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol,
      job: {},
      newLineItemKey: '',
      activeTab: 0
    }
  },
  computed: {
    showJobDetailModal: {
      // get the modal active state
      get: function () {
        return this.$store.getters.showJobDetailModal
      },
      set: function (newValue) {
        this.$store.commit('toggleShowJobDetailModal')
        // close the modal by clearings the working Job from the store
        this.$store.commit('setJobDetailModalJob', {})
      }
    },
    currentJob () {
      // the currently worked on job object
      return this.$store.getters.getJobDetailModalJob
    },
    clients () {
      // get an array of client objects from the store
      return this.$store.getters.clients
    },
    listId () {
      // this jobs ListId
      return this.job.listId
    },
    invoiceButtonText () {
      if (this.job.hasInvoice) {
        return 'view invoice'
      } else {
        return 'create invoice?'
      }
    },
    quoteButtonText () {
      if (this.job.hasQuote) {
        return 'view quote'
      } else {
        return 'create quote?'
      }
    },
    modalHeight () {
      // this extends the height of the modal to take care of the added tax breakdown info
      // we could just have the modal resize but then the user has to hunt for the menu items as they move vertically
      if (this.group.chargeTax) {
        return { minHeight: '493px', paddingTop: '18px' }
      } else {
        return { minHeight: '433px', paddingTop: '18px' }
      }
    },
    hasProAccess () {
      return this.$store.getters.hasProAccess
    }
  },
  watch: {
    // when current job changes update this job
    currentJob: {
      handler: function () {
        this.job = this.currentJob
        // this ensures a key isn't created until a job is present
        this.getLineItemKey()
        this.client_nameFormatted = this.job.clientName
      },
      deep: true
    },
    showJobDetailModal (val) {
      if (val) {
        // ensures that the first tab is always shown on opening
        this.activeTab = 0
      }
    }
  },
  methods: {
    closeWindow () {
      // force the blurring of the client name dropdown which triggers it's update
      // this is to stop the dialog closing before the name is saved
      this.$refs.clientname.blur()
      // wait..
      this.$nextTick(() => {
        // and close the window
        this.showJobDetailModal = false
      })
    },
    updateJob (job) {
      // this.$refs.clientname.blur()
      // keep ui state uptodate
      this.$store.commit('setJobDetailModalJob', job)
      // sync to FB
      const listId = this.listId
      this.$store.dispatch('updateJob', { listId: listId, payload: job })
      // if the job has an invoice then update that to match
      // but wait for nextTick to allow lineItems callback to run through
      this.$nextTick(() => {
        if (this.job.hasInvoice) {
          // build update object
          const invoiceUpdate = {
            id: this.job.id, // we need the id to update on
            lineItems: this.job.lineItems,
            amount: this.job.amount,
            taxIncluded: this.job.taxIncluded,
            totalTaxPortion: this.job.totalTaxPortion,
            totalNetAmount: this.job.totalNetAmount,
            title: this.job.title,
            clientName: this.job.clientName
          }
          // do the write
          this.$store.dispatch('updateInvoice', invoiceUpdate)
        }
      })
    },
    saveClientName () {
      // save the client name which will either be an object from select or a typed in value
      // check we have something
      if (this.client_nameFormatted !== null && this.client_nameFormatted !== '') {
        // if it's a string...
        if (typeof this.client_nameFormatted === 'string') {
          // .. use the straight string variable and save the job
          this.job.clientName = this.client_nameFormatted
          this.updateJob(this.job)
        } else {
          // else it's an object from the select so grab the name value from it
          this.job.clientName = this.client_nameFormatted.name
          this.updateJob(this.job)
        }
      }
    },
    updateJobFromLineItems (payload) {
      // create replacement Job object with updated items from lineItems component
      const newJob = {
        ...this.job,
        amount: payload.amount,
        totalTaxPortion: payload.totalTaxPortion,
        totalNetAmount: payload.totalNetAmount,
        title: payload.title,
        taxIncluded: payload.taxIncluded,
        lineItems: payload.lineItems
      }
      // update the job)
      this.updateJob(newJob)
    },
    getLineItemKey () {
      const listId = this.listId
      const jobId = this.job.id
      const groupId = this.user.group
      const ref = firebase.database().ref('lists/' + groupId + '/list' + listId + '/' + jobId + '/lineItems').push().key
      this.newLineItemKey = ref
    },
    doSplitInvoice () {
      this.$store.commit('setSplitInvoiceModalJob', this.job)
      this.$store.commit('toggleShowSplitInvoiceModal')
    },
    goToInvoice (invoiceId) {
      this.showJobDetailModal = false
      this.$router.push({ name: 'Invoice', params: { invoice_id: invoiceId } })
    },
    goToQuote (quoteId) {
      this.showJobDetailModal = false
      this.$router.push({ name: 'Quote', params: { quote_id: quoteId } })
    },
    updateDate (payload) {
      const { dateName, dateOut } = payload
      this.job[dateName] = dateOut
      this.updateJob(this.job)
    },
    copyJob () {
      navigator.clipboard.writeText('Hi there').then(() => {
      /* clipboard successfully set */
        this.$store.dispatch('addNotification', { text: 'Copied to clipboard.', type: 'primary' })
      }, function () {
        /* clipboard write failed */
      })
    }
  }
}
</script>
<style lang="scss" scoped>

.job-menu{
  background:var(--background-grey) !important;
}
.taskstab,
.timetab,
.notestab,
.jobtab {
  margin-top:7px;
  .card__text,
  .card__title {
    padding: 0 16px;
  }
}
.jobtab {
  .input-group {
    margin-top: 13px;
  }
}
.job-edit{
  input, textarea {
    font-size:.9rem;
  }
  textarea{
    padding:0;
  }
}
  .v-card__text{
    padding-top:10px;
    padding-bottom:0;
  }
  .v-text-field{
    margin-bottom:10px;
    input{
      padding-bottom:2px;
    }
  }
  .v-label {
  font-size:14px;
  }
  .v-text-field__prefix {
    font-size:.9rem;
    text-align:left;
    padding-top:5px;
    padding-right:2px;
    width:auto;
  }
  .theme--light.v-text-field .v-input__slot:before {
    border-color:rgba(178,178,178,.5)
  }
  .v-input__icon--append{
  .theme--light.v-icon{
    color:rgba(204,204,204,1)
    }
  }
  .v-tabs__item{
    .v-icon{
      // color: rgba(0,0,0,.3);
      font-size:18px;
      color:var(--light-text);
    }
    &.v-tabs__item--active{
      .v-icon{
        color:var(--dark-text);
      }
    }
  }

  .taskstab, .timetab{
    .v-card__title{
      padding-top:0px;
      padding-bottom:0;
    }
    .v-card__text{
      padding-top:0px;
      padding-bottom:10px;
    }
    .v-text-field{
      padding-top:0;
      margin-top:4px;
    }
    .v-input--selection-controls{
      margin-top:7px;
    }
  }
  .v-list__tile{
    font-size:12px;
    height:35px;
  }
.fadein{
  animation: fadein .8s;
}
@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

.head-slide{
  span{
    position:absolute;
    // opacity:0;
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: .4s;
}
.slide-enter-to {
  opacity:1;
}
.slide-enter {
  transform: translate(100%, 0);
  opacity:0;
}
.slide-leave-to {
  transform: translate(-100%, 0);
  opacity:0;
}

</style>
